import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';
import AiMessagingKnowledgeCenterController from 'uplisting-frontend/pods/ai-messaging/knowledge-center/controller';

interface IParams extends Record<string, unknown> {
  categories: string[];
  statuses: string[];
  propertyIds: string[];
  highlightQaPairId?: string;
}

export default class AiMessagingKnowledgeCenterRoute extends ProtectedRoute {
  baseRoute = 'ai-messaging';

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  async model(params: IParams) {
    const controller = this.controllerFor(
      `${this.baseRoute}.knowledge-center`,
    ) as AiMessagingKnowledgeCenterController;

    Object.assign(controller, params);

    if (params.propertyIds?.length) {
      controller.activeTab = 'property';
    }

    await Promise.all([
      this.propertyRepository.findAll(),
      controller.fetchData(),
    ]);

    return {
      properties: this.propertyRepository.peekAll(),
    };
  }

  setupController(
    controller: AiMessagingKnowledgeCenterController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    controller.properties = model.properties;
  }

  resetController(
    controller: AiMessagingKnowledgeCenterController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      Object.assign(controller, {
        qaPairs: [],
        searchQuery: '',
        categories: [],
        statuses: [],
        propertyIds: [],
        activeTab: 'global',
        isPanelOpen: false,
        editingQaPair: undefined,
        deletingQaPair: undefined,
        highlightQaPairId: undefined,
        isFileUploadPanelOpen: false,
      });
    }
  }
}

export type AiMessagingKnowledgeCenterRouteModel =
  RouteModel<AiMessagingKnowledgeCenterRoute>;
